import { Component, computed, EventEmitter, inject, OnDestroy, OnInit, Output, Signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { BoxComponent } from '@shared/components/box/box.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { TextboxComponent } from '@shared/components/form/textbox/textbox.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { SubtitleBlockComponent } from '@shared/components/subtitle-block/subtitle-block.component';
import { Bunker, NoonReportDetail } from '@vessel-reports/noon/state/noon.types';
import { PortActions } from '@vessel-reports/port/state/port.action';
import { PortState } from '@vessel-reports/port/state/port.state';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'input-inventory-rob',
  imports: [BoxComponent, SubtitleBlockComponent, TextboxComponent, HeaderComponent, FooterComponent, ReactiveFormsModule, TranslocoPipe],
  templateUrl: './input-inventory-rob.component.html',
  styleUrl: './input-inventory-rob.component.scss'
})
export class InputInventoryRobComponent implements OnInit, OnDestroy {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  @Output() back: EventEmitter<void> = new EventEmitter<void>();
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  form: UntypedFormGroup;
  detailNoonReport: Signal<NoonReportDetail> = computed(() => this._portReportState.detailPortReport());
  detailBunker: Signal<Bunker> = computed(() => this._portReportState.detailBunker());
  private readonly _portReportState: PortState = inject(PortState);
  private readonly _portReportActions: PortActions = inject(PortActions);
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private _formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this._formBuilder.group({
      vessel_report_id: [this.detailNoonReport().id],
      date_report: [this.detailNoonReport().date_report],
      rob_hfo: [this.detailBunker()?.rob_hfo, Validators.required],
      rob_mgo: [this.detailBunker()?.rob_mgo, Validators.required],
      rob_freshwater: [this.detailBunker()?.rob_freshwater, Validators.required],
      rob_luboil_me_cyl: [this.detailBunker()?.rob_luboil_me_cyl, Validators.required],
      rob_luboil_me_sys: [this.detailBunker()?.rob_luboil_me_sys, Validators.required],
      rob_luboil_ge_sys: [this.detailBunker()?.rob_luboil_ge_sys, Validators.required]
    });
  }

  ngOnDestroy() {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onBack: FunctionType = () => {
    this.back.emit();
  };

  onSave: FunctionType = () => {
    this._portReportActions.actions.createReportBunker({ body: this.form.getRawValue() });
    this._portReportActions.actions.createReportBunkerSuccess$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this._portReportActions.actions.getDetailPortReport({ report_id: this.detailNoonReport().id });
      this.save.emit(this.form.getRawValue());
    });
  };
}
